export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Yesterday"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chat"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Today"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Monday"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tuesday"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wednesday"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Thursday"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Friday"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Saturday"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sunday"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["January"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["February"])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["March"])},
  "14": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["April"])},
  "15": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["May"])},
  "16": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["June"])},
  "17": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["July"])},
  "18": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["August"])},
  "19": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["September"])},
  "20": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["October"])},
  "21": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["November"])},
  "22": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["December"])},
  "23": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["You"])},
  "24": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Admin"])}
}